import React from 'react';
import { Label } from "flowbite-react";
import { HiX } from "react-icons/hi";
// @ts-ignore
import DatePicker from "react-datepicker";

interface MilestoneRowProps {
  data?: any;
  onRemove: () => void;
  onChange: (field: string, value: any) => void;
}

const MilestoneRow: React.FC<MilestoneRowProps> = ({ data = {}, onRemove, onChange }) => (
  <div className="smap-drawer__milestone-row">
    <div className="flex-1">
      <Label>Name *</Label>
      <input 
        type="text" 
        className="smap-drawer__input !py-2 !text-sm mt-1" 
        placeholder="Milestone Name" 
        value={data.name || ''}
        onChange={(e) => onChange('name', e.target.value)}
      />
    </div>
    <div className="flex-1">
      <Label>Date *</Label>
      <DatePicker 
        className="smap-drawer__input !py-2 !text-sm mt-1" 
        selected={data.start_date ? new Date(data.start_date) : null}
        onChange={(date: Date) => onChange('start_date', date?.toISOString())}
      />
    </div>
    <div className="flex-shrink-0">
      <Label>Color</Label>
      <input 
        type="color" 
        className="block w-[50px] h-[30px] rounded-lg border-none p-0 mt-1" 
        value={data.color || '#000000'}
        onChange={(e) => onChange('color', e.target.value)}
      />
      <div className="smap-drawer__remove-item" onClick={onRemove}>
      <HiX />
    </div>
    </div>
    
  </div>
);

export default MilestoneRow;
